import type { IProvider, ProviderConfig } from '../types';
import { FakeProvider } from './Fake';
import { IuguProvider } from './Iugu';
import { PagarmeProvider } from './Pagarme';
import { StripeProvider } from './Stripe';
import { VindiProvider } from './Vindi';
import { ZoopProvider } from './Zoop';

type ProviderFactory = (config: ProviderConfig) => IProvider | null;

const factories: Record<string, ProviderFactory> = {
  pagarme: (config) => {
    const apiKey = config.config.find((c) => c.name === 'public_key')?.value;
    if (!apiKey) return null;
    return new PagarmeProvider(apiKey, config.gatewayConfigId);
  },
  stripe: (config) => {
    const publicKey = config.config.find((c) => c.name === 'public_key')?.value;
    if (!publicKey) return null;
    return new StripeProvider(publicKey, config.gatewayConfigId);
  },
  vindi: (config) => {
    const publicKey = config.config.find((c) => c.name === 'public_key')?.value;
    if (!publicKey) return null;
    const environment = config.config.find((c) => c.name === 'environment')?.value;
    return new VindiProvider(publicKey, config.gatewayConfigId, environment);
  },
  iugu: (config) => {
    const accountId = config.config.find((c) => c.name === 'account_id')?.value;
    if (!accountId) return null;
    return new IuguProvider(accountId, config.gatewayConfigId, config.isTest);
  },
  zoop: (config) => {
    const marketplaceId = config.config.find((c) => c.name === 'marketplace_id')?.value;
    const tokenizationKey = config.config.find((c) => c.name === 'tokenization_key')?.value;
    if (!marketplaceId || !tokenizationKey) return null;
    return new ZoopProvider(marketplaceId, tokenizationKey, config.gatewayConfigId);
  },
  fake: (config) => {
    return new FakeProvider(config.gatewayConfigId);
  },
};

export function createProviders(
  configs: ProviderConfig[],
): Array<{ provider: IProvider; config: ProviderConfig }> {
  const result: Array<{ provider: IProvider; config: ProviderConfig }> = [];

  for (const config of configs) {
    const factory = factories[config.provider];
    if (!factory) continue;

    const provider = factory(config);
    if (!provider) continue;

    result.push({ provider, config });
  }

  return result;
}
